import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../reduxToolkit/hooks';
import { routes } from './routes';
import { UserRole } from '../types/Forms';

type Props = {
  allowedRoles: string[];
};

const RoleRoute = ({ allowedRoles }: Props) => {
  const { isAuthenticated, role } = useAppSelector((state) => state.auth);
  console.log('role', role);

  if (!isAuthenticated || !role) {
    return <Navigate to={routes.Login} replace />;
  }

  if (!allowedRoles.includes(role)) {
    // Redirect unauthorized users to their default page
    if (role === UserRole.ADMIN) {
      return <Navigate to={routes.Dashboard.Default} replace />;
    }
    if (role === UserRole.ASSISTANT) {
      return <Navigate to={routes.Dashboard.Default} replace />;
    }
    if (role === UserRole.STUDENT) {
      return <Navigate to={routes.Students.StudentPrivateCourses} replace />;
    }
    // Fallback if role doesn't match any known role
    return <Navigate to={routes.Login} replace />;
  }

  return <Outlet />;
};

export default RoleRoute;
